import { EnTypedValue } from '../enum/en-typed-value.enum';

export interface ITypedValue {
     type: EnTypedValue;
     string: string;
     value: any;
}
